<template><div><h1 id="projektpartner-mit-offenen-gesuchen" tabindex="-1"><a class="header-anchor" href="#projektpartner-mit-offenen-gesuchen"><span>Projektpartner mit offenen Gesuchen</span></a></h1>
<p>Projektpartner mit offenen Gesuchen — Listet die Aktionen der Projektpartner auf</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Dies ist eine spezielle Auswertung der Projektpartner, die zu jedem noch nicht abgeschlossenem Gesuch die Liste der dazugehörigen Aktionen auflistet.</p>
<p>Pfad: <code v-pre>Personen → Auswertungen → Projektpartner mit offenen Gesuchen</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Personenmerkmale</dt>
<dd>Personenmerkmal</dd>
<dt>Gesuchsdatum von</dt>
<dd>leer = unbegrenzt, inklusive</dd>
<dt>Gesuchsdatum bis</dt>
<dd>leer = unbegrenzt, inklusive</dd>
<dt>Sortierungsmerkmale</dt>
<dd>Ausgabe sortiert nach Merkmal</dd>
<dt>abgeschlossene Gesuche</dt>
<dd>Anzeigen von abgeschlossenen Gesuchen, u = unterdrücken nicht anzeigen / a = anzeigen</dd>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Landscape)</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Adrnum</td>
<td>Personen-ID</td>
</tr>
<tr>
<td>Name</td>
<td>Adressname</td>
</tr>
<tr>
<td>Ort</td>
<td>Adressort</td>
</tr>
<tr>
<td>Projekt</td>
<td>Projektnummer</td>
</tr>
<tr>
<td>Bezeichnung</td>
<td>Kurzbezeichnung des Projekts</td>
</tr>
<tr>
<td>Aktion</td>
<td>Aktion</td>
</tr>
<tr>
<td>Datum</td>
<td>Datum der Aktion</td>
</tr>
<tr>
<td>Betrag</td>
<td>Responsewert der Aktion</td>
</tr>
<tr>
<td>Kommentar</td>
<td>Dieses Feld ist immer leer, wird von funtrade nicht verwendet. Dient für manuelle Einträge auf den Ausdrücken.</td>
</tr>
</tbody>
</table>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line">Datenausgabe                          19.02.2004 15:17:24 svw  Seite     0</span>
<span class="line"></span>
<span class="line">                      Projektpartner mit offenen Gesuchen</span>
<span class="line">       Personenmerkmale........: APPA</span>
<span class="line">       Gesuchsdatum von......: 01.01.2003 bis: 31.01.2003</span>
<span class="line">       Sortierungsmerkmale...:</span>
<span class="line">       abgeschlossene Gesuche: u</span>
<span class="line"></span>
<span class="line">  Adrnum Name              Ort       Projekt Bezeichnung     Aktion Datum          Betrag Kommentar</span>
<span class="line">-------- ----------------- --------- ------- --------------- ------ ---------- ---------- ----------------------</span>
<span class="line">  958548 Kanton Zürich     Zürich    826442  MO42            gesu   14.01.2003       0.00</span>
<span class="line">                                     849631  KR31            gesu   14.01.2003       0.00</span>
<span class="line">Total Anzahl: 1</span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div></div></template>


